import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ComponenteSpinner } from '../pages/adminComponents/ComponenteSpinner';
import Cookies from 'js-cookie';

export const IniciarSesion = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {       
    const redirect = sessionStorage.getItem("redirect_after_login") || "/inicio";
    const token = Cookies.get("token");

    if (!sessionStorage.getItem("login_redirect_in_progress") && token) {
      sessionStorage.setItem("login_redirect_in_progress", "1");

      try {
        // Validar si redirect es un URL absoluto
        const url = new URL(redirect, window.location.origin);

        if (url.origin !== window.location.origin) {
          // Es externo → redirigir al sitio externo

          sessionStorage.removeItem("login_redirect_in_progress");
          sessionStorage.removeItem("redirect_after_login");
          Cookies.remove("token");
          const email = ""
          postAndRedirect(redirect, { token, email });
        } else {
          // Es interno → usar navigate
          navigate(redirect, { replace: true });
        }
      } catch {
        // Si el redirect no es un URL válido → navegar interno
        navigate(redirect, { replace: true });
      } finally {        
        sessionStorage.removeItem("login_redirect_in_progress");
        sessionStorage.removeItem("redirect_after_login");
      }

    }
  }, []);

  return <ComponenteSpinner />;
};

function postAndRedirect(url, payload) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.acceptCharset = 'UTF-8'; // ayuda a parsers del lado receptor
  Object.entries(payload).forEach(([k, v]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = v ?? '';
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

export default IniciarSesion;